<script setup lang="ts">
import { onMounted, ref } from "vue";
// @ts-ignore
import useUsers from "@/hooks/useUsers";
// @ts-ignore
import { useRoute } from "vue-router/auto";
import { useToast } from "vue-toastification";

const { fetchUser, updateUser } = useUsers();
const route = useRoute();
const toast = useToast();
const form = ref<HTMLFormElement | null>(null);
const formValid = ref(true);
const userData = ref({
  name: null,
  email: null,
  title: null,
  api_token: null,
  active: null,
  phone: "",
  pin: null,
  v3_login_timeout_ms: null,
  enforce_v3_login_timeout: null,
  pin_confirmation: null,
  password: null,
  password_confirmation: null,
});

const phoneRules = [
  (v: string) => !!v || 'Phone number is required.',
];

onMounted(async () => {
  await fetchUser(route.params.id).then((response: any) => {
    userData.value = response;
  });
});

const handleUpdateUser = async () => {
  if (form.value) {
    const { valid } = await form.value.validate();
    if (!valid) {
      return;
    }
  }

  const response = await updateUser(route.params.id, userData.value);
  if (response) {
    const updatedUser = await fetchUser(route.params.id);
    if (updatedUser) {
      userData.value = updatedUser;
    }
  }
};
</script>

<template>
  <v-card flat class="mx-4 mt-8">
    <v-card-title>Edit Profile</v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="formValid">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="userData.name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="userData.email" label="E-mail Address"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-phone-input
              v-model="userData.phone"
              name="phone"
              :rules="phoneRules"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="userData.title" label="Title"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="userData.active"
              :items="[
                { text: 'Active', value: true },
                { text: 'Disabled', value: false },
              ]"
              label="Status"
              item-title="text"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="d-flex">
            <v-switch
              v-model="userData.enforce_v3_login_timeout"
              color="primary"
              label="Enforce Login Timeout"
            ></v-switch>
            <v-text-field
              v-if="userData.enforce_v3_login_timeout"
              v-model="userData.v3_login_timeout_ms"
              class="ml-4"
              label="Timeout (ms)"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions class="flex justify-end">
      <v-btn
        color="primary"
        variant="flat"
        @click="handleUpdateUser"
        >Update Profile</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
